import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> | boolean {
    // First check if token exists
    if (!this.authService.isAuthenticated()) {
      console.log('No token found, redirecting to login');
      this.router.navigate(['/login']);
      return false;
    }

    console.log('Token found, validating session with backend');
    // Validate session with backend
    return this.authService.validateSession().pipe(
      map(isValid => {
        if (!isValid) {
          console.log('Session validation failed, redirecting to login');
          this.router.navigate(['/login']);
          return false;
        }
        console.log('Session validation successful');
        return true;
      }),
      catchError((error) => {
        console.error('Session validation error:', error);
        this.router.navigate(['/login']);
        return of(false);
      })
    );
  }
}
